module.exports = __webpack_public_path__ + "assets/media/front-banner.626245ce.svg";